<template>
    <div class="c-language-text">
        <ul>
            <li :class="currentLang === 'vi' ? 'active' : ''"><a @click="setLocale('vi')" href="#">Tiếng Việt</a></li>
            <li :class="currentLang === 'en' ? 'active' : ''"><a @click="setLocale('en')" href="#">English</a></li>
        </ul>
    </div>
</template>

<script>
    import getUserLocale from 'get-user-locale';

    export default {
        data: function () {
            return {
                currentLang: null
            }
        },
        methods: {
            setLocale: function (locale) {
                this.$i18n.locale = locale;
                this.$service.defaults.headers.common['Accept-Language'] = locale;
                this.$bgService.defaults.headers.common['Accept-Language'] = locale;
                this.currentLang = locale;
                localStorage.setItem('locale', locale);
            }
        },
        created() {
            this.currentLang = localStorage.getItem('locale');
            if (!this.currentLang) {
                this.currentLang = getUserLocale().split('-')[0];
            }
            this.setLocale(this.currentLang);
        }
    };
</script>
